import { render } from "./collectStoreItem.vue?vue&type=template&id=2dbe0e2a"
import script from "./collectStoreItem.vue?vue&type=script&lang=js"
export * from "./collectStoreItem.vue?vue&type=script&lang=js"

import "./collectStoreItem.vue?vue&type=style&index=0&id=2dbe0e2a&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__